import LTable from './src/main'

/* istanbul ignore next */
LTable.install = function(Vue) {
  Vue.component(LTable.name, LTable)
}

export default LTable
